import {ServerRandomUtils} from '@fantasmagames/prototype/src/utils/ServerRandomUtils';
import {
	CHEST_EXPLODE,
	CHEST_RESPIN, CHEST_WILD, E,
	H1,
	H2,
	H3,
	H4,
	H5, KEY,
	L1,
	L2,
	L3,
	L4, MIMIC_CHEST, SC,
	W,
} from '@fantasmagames/prototype/src/symbols/ServerSymbols';
import {ServerSymbolPosition, ServerWinLine, ServerWinSymbols} from '@fantasmagames/prototype/src/win/ServerWinLine';
import {ServerWaysWinChecker} from '@fantasmagames/prototype/src/win/ServerWaysWinChecker';
import {ServerCheats} from '@fantasmagames/prototype/src/cheats/ServerCheats';
import {ExpandedWildData} from '@fantasmagames/prototype/src/reels/ServerAvalancheReelsRound';

export enum Reelsets {
	BASIC = 0,
	MIMIC_FS = 1,
	FREE_SPINS = 2,
}

export interface CurrentReelsCombination {
	visibleReels: number[][];
	visibleReelsPositions: number[];
}

export interface MegablockData {
	position: ServerSymbolPosition;
	size: number;
	isFull: boolean;
}

export class ServerAvalancheReels {
	public static baseGameReels: number[][];

	public static mimicFreeSpinsReels: number[][];

	public static ROWS: number = 6;
	public static REELS: number = 6;

	public static readonly FIRST3REELS: number[][] = [
		[0, 1, 2],
		[0, 2, 1],
		[1, 0, 2],
		[1, 2, 0],
		[2, 0, 1],
		[2, 1, 0],
	];

	public static readonly SECOND3REELS: number[][] = [
		[3, 4, 5],
		[3, 5, 4],
		[4, 3, 5],
		[4, 5, 3],
		[5, 3, 4],
		[5, 4, 3],
	];

	protected _currentReelOrder: number[];

	private _currentMegablock: MegablockData;

	constructor() {
		this.initializeReels();
	}

	protected initializeReels(): void {
		ServerAvalancheReels.baseGameReels = [
			[L4, H5, H1, L1, H4, L3, L1, L3, H4, L1, H3, L3, H5, L1, H3, L1, H5, L3, H4, L3, L2, L1, L3, H1, H5, L1, H5, L1, L3, H3, L1, H5, L3, H4, L1, L3, H5, H3, L3, L1, H2, L3, H5, L1, H3, H4, L3, L1, H5, L1, L3, L1, H5, H1, L1, H4, L3, L1, L3, H3, H4, L3, H4, L3, L1, H5, H3, L3, L1, L3, H4, L3, L1, L3, H4, L1, H5, L1, L3, H5, H3, H1, L1, H5, L3, L1, H1, L3, H5, L3, H4, L1, L3, H3, H5, L3, L1, L3, H4, L1, H4, L3, L1, H3, L3, L1, H5, H1, L3, H4, L1, L3, H4, L3, H5, H1, L3, L1, H5, L3],
			[L1, L3, L4, H1, L2, H4, L4, H1, L4, L2, H4, L3, H4, L4, L2, H1, L2, H4, L4, H4, H5, L3, L4, H2, L2, H4, L3, H4, L3, L2, H4, H1, H4, L4, H4, L4, H4, L2, H2, L4, H3, L3, L2, L3, H1, L2, H4, L2, L4, H4, L2, L4, H1, L4, H4, L4, H4, L2, H1, L4, L2, H4, L2, H4, L4, L3, H2, L2, H4, L4, H4, L4, H4, L2, L3, H4, L3, H2, L3, H1, L2, L3, H4, L4, H4, L2, H4, L2, L3, H1, L2, H4, L2, H4, L3, L4, H2, H4, L2, L3, H1, L4, L3, H4, L3, H4, L2, L3, H2, L4, H4, L4, H4, L2, H4, L3, H2, L3, L2, H4],
			[L3, L2, H3, L1, L4, H5, L2, H2, L1, L4, H5, L4, H5, L1, H2, L2, L1, H5, L2, H5, H4, L2, H5, L4, H2, L2, H5, L2, L1, H5, H2, L2, L4, L1, H5, L1, H2, H5, L2, L1, H1, L2, H5, L2, H2, L4, L2, H5, L4, H5, L2, H5, L2, L1, H5, L1, H2, H5, H3, H5, L4, L2, H5, L1, L4, L1, H2, L1, L2, H5, L1, L2, H2, H5, L2, L1, L4, H5, L2, H3, L2, L4, H5, L2, H5, L2, H3, L2, H5, L2, H5, L1, H5, L4, L1, H2, L2, L1, H5, L2, H3, L1, L4, H5, L4, H5, L4, H5, H2, L2, H5, L4, H5, L1, L4, L2, H3, L2, L4, H5],
			[L1, L2, L4, H3, L2, H4, L2, L3, H1, L4, H4, L3, H4, L2, L4, H4, L3, H4, H3, L3, H2, L2, H4, L4, H1, L3, L2, H4, L4, H3, H4, L3, H4, L3, L4, L2, H4, L4, H4, L2, H1, L2, H4, L4, L2, L4, H3, L4, H4, L4, H4, H3, L4, L2, L3, H4, L2, L4, H4, H3, L3, L4, H4, L2, L3, H3, H4, L3, L4, H4, L4, L3, H4, H1, L4, L3, H4, L3, L4, H3, H5, L3, H4, L2, H4, L2, L3, H3, L3, H4, L2, H4, L2, H1, H4, L3, L4, H4, L2, L3, L2, H3, L3, H4, L3, H4, L4, H1, L3, L2, H4, L4, H4, L2, L4, H1, L2, H4, L2, H4],
			[H1, H4, L4, H4, L1, L4, H4, H2, L1, L4, L1, H5, L4, H1, H5, L4, L1, H5, L1, L4, H2, H4, L4, L1, H5, L1, L4, H4, L1, L4, H1, H5, L4, L1, H2, H4, L1, L4, L1, H4, H3, L1, H5, H2, L4, L1, H4, L4, L1, H5, L4, L1, L4, H5, H2, L1, L4, H5, H1, L4, L2, H5, L1, L4, H2, H5, L1, L4, H5, L4, L1, L4, H2, L1, H5, L4, L1, H4, L1, H4, L3, H2, L4, H5, L1, L4, L1, H1, L1, H5, L1, H5, L4, H2, H5, L1, L4, H4, L4, L1, H1, H5, L4, L1, H5, L4, L1, H5, L4, H1, L1, L4, H4, L4, H5, H1, L1, L4, H5, L1],
			[H1, L1, H3, L3, H5, L1, L2, H5, L3, L1, H2, L2, H5, L3, H2, H5, L3, H5, L2, L1, H4, L3, L2, H3, L1, H5, L2, H5, L2, H2, L2, L3, H5, L1, H5, L1, L2, H3, L3, H5, L2, H5, L3, H5, L2, H3, H5, L3, H5, L3, H5, L2, H3, L2, H5, L3, L2, H3, H5, L2, L4, L3, H5, L3, L2, H2, L3, L2, L1, L2, H5, L1, L2, H3, L2, H5, L2, H5, L1, H2, H5, L1, L2, H5, L2, H5, L3, H3, H5, L1, L2, H5, L3, L1, L2, L3, H2, L1, H5, L3, H2, H5, L2, L3, L1, H5, L2, L3, H3, L2, H5, L3, H5, L1, H5, L1, H5, H2, H5, L3],
		];

		ServerAvalancheReels.mimicFreeSpinsReels = [
			[L3, L1, H5, L2, L3, L2, H3, L1, H4, L1, L4, H5, L1, H5, L3, L1, H1, H5, L1, H4, H1, H4, L1, L3, L2, L1, L3, L4, H2, H5, L2, H4, L4, H5, L1, L3, H5, L4, H3, L4, L1, H2, L3, H4, H5, H4, L1, L2, L1, H1, H4, L1, L4, L1, H5, H3, L1, L4, L3, H4, L3, L4, H5, L2, H1, H4, L3, H5, L4, H5, L4, L2, L1, H1, L1, L3, H1, L4, L3, H5, L2, H5, H4, H1, H4, L1, L3, L2, H5, L4, H2, H4, L4, L2, L3, L1, H5, H4, L1, L3, L2, H2, L2, H5, L2, L1, L3, H4, H2, L2, L1, L3, H3, H5, L4, H4, L1, L4, H4, H5],
			[L3, H4, L4, H4, H3, L1, H2, H4, L4, L2, L1, H4, L2, L3, H2, L1, L2, L1, H4, L4, L1, H1, H5, L4, L3, H5, H4, H1, H4, L2, L3, H4, L1, L3, L4, L2, L1, H4, H5, L3, H1, L3, L2, L3, H3, L2, H5, L1, H5, L4, H3, H5, H4, L1, L2, H2, L3, L1, L4, H5, L4, H4, H1, H4, L1, L4, L1, L2, L3, L4, H1, L3, H5, L3, H4, L3, H1, L2, L4, H5, L4, H5, L4, H4, L3, H1, L4, L2, H4, H5, L1, H4, L4, L1, H2, L3, L4, L2, H4, L2, H2, H4, H5, L4, L2, L1, H2, L2, L3, H5, L1, H1, L4, H4, L4, H5, L3, L4, L2, H1],
			[H1, L4, L2, H4, L4, H4, H2, L3, H5, L4, L2, L1, L2, L3, H4, H3, H5, L3, L1, H4, H5, H3, L2, L1, L3, H5, L1, H4, H3, L2, L4, H4, L1, L2, H1, H4, L3, L2, L4, H4, L2, L1, L3, H5, H1, L1, L2, H4, L1, L2, L4, H1, L4, H5, L4, H3, H4, L3, L4, L1, H5, L1, H2, L1, L3, H5, L4, H4, L3, H1, L2, L3, H5, L2, H4, H5, L4, H4, L4, L3, L2, H4, L3, H1, H5, H1, L2, H5, L3, L1, H3, L4, H5, L2, L1, L2, L3, L1, H2, L3, H5, H4, H5, L4, H4, H3, L3, L2, L4, L1, L4, L1, H2, H4, L3, L4, H4, L4, L2, H5],
			[H5, L3, L4, H5, L1, H1, H5, L4, L3, H3, L3, L4, L3, L4, H1, L1, H4, L2, H4, L2, H2, H5, H4, L2, L4, L3, L2, L3, H4, L1, H3, L4, H4, L1, L3, H1, L2, H4, L1, H5, H4, L1, L3, H2, L3, L1, H5, L3, L2, H3, L1, H5, H4, L3, L2, L3, H5, H1, L3, H5, L2, L3, H4, H1, L4, H4, L1, L3, L4, H3, H5, L2, L1, H5, L3, H5, H3, L4, L1, L2, H5, L3, L4, L3, H2, L2, H4, L4, H4, H5, L3, H2, L4, H5, H4, L3, L4, H5, L1, L2, L3, H5, L4, H3, H2, L1, H5, L4, H4, L4, L3, L4, H3, L2, H5, H4, L1, L4, L2, H4],
			[H4, L1, L4, L3, H5, L2, H4, L2, H3, L1, L2, H2, L4, L2, H2, L1, H5, L2, H5, L3, L4, H1, L2, H5, L3, H4, L2, H5, H1, H5, L2, H4, L3, L2, H4, L3, H2, L2, L1, H5, L2, H4, L4, L1, L3, L1, H4, L4, H2, H4, H3, L4, L3, L4, L1, H5, L3, L2, H3, L2, H5, H4, L4, L1, H2, L3, L4, H4, L4, H1, L1, H4, L2, L3, H5, L3, H3, L1, H4, L2, H5, L4, H4, H5, H1, L3, L1, L3, L2, L3, L2, H5, L4, H3, L4, H5, L4, L2, H4, H2, H5, L2, L1, H4, H1, L2, L4, L3, H4, H5, L1, H3, L2, H4, L2, H5, L3, L2, L3, L1],
			[H4, H1, L2, L4, H4, L1, H4, L1, L4, L3, L2, H2, L2, H4, L1, H1, H5, H4, L3, L2, H2, L1, L3, L2, L1, H5, L3, H3, L1, H4, H5, L3, L1, H4, H2, H4, L1, L2, L3, L1, L3, H2, L4, H5, L2, L3, H5, H4, L1, L3, H1, L4, L3, H4, L3, L4, H1, L3, H4, L3, H5, H4, L2, H4, L3, H2, L1, H5, L3, L1, H1, L3, L2, L4, H5, L2, H5, H3, L1, H4, L1, L2, L1, L2, H4, H2, H4, L3, L2, H4, H2, H4, L2, L1, L3, L4, H4, H3, L1, L2, H4, H5, L3, L1, L4, H3, H4, L3, L4, L2, L1, L4, H3, L3, H4, L4, H4, H5, L1, H5],
		];
	}

	public getReelset(reelset: Reelsets): number[][] {
		switch (reelset) {
			case Reelsets.BASIC:
				return ServerAvalancheReels.baseGameReels;
			case Reelsets.MIMIC_FS:
				return ServerAvalancheReels.mimicFreeSpinsReels;
			case Reelsets.FREE_SPINS:
				return ServerAvalancheReels.baseGameReels;
			default:
				return null;
		}
	}

	protected generateReelsOrder(): number[] {
		const reelsOrder: number[] = [
			...ServerAvalancheReels.FIRST3REELS[ServerRandomUtils.randomInt(0, 5)],
			...ServerAvalancheReels.SECOND3REELS[ServerRandomUtils.randomInt(0, 5)],
		];

		return reelsOrder;
	}

	public generateNewCombination(reelset: Reelsets, cheats: ServerCheats): CurrentReelsCombination {
		this._currentReelOrder = this.generateReelsOrder();

		if (cheats.isCheatsEnabled && cheats.firstThreeReelsCombination.length === 3){
			this._currentReelOrder[0] = cheats.firstThreeReelsCombination[0];
			this._currentReelOrder[1] = cheats.firstThreeReelsCombination[1];
			this._currentReelOrder[2] = cheats.firstThreeReelsCombination[2];
		}
		if (cheats.isCheatsEnabled && cheats.secondThreeReelsCombination.length === 3) {
			this._currentReelOrder[3] = cheats.secondThreeReelsCombination[0];
			this._currentReelOrder[4] = cheats.secondThreeReelsCombination[1];
			this._currentReelOrder[5] = cheats.secondThreeReelsCombination[2];
		}

		const positions: number[] = [];
		const curReels: number[][] = this.getReelset(reelset);
		for (let reelIndex: number = 0; reelIndex < curReels.length; reelIndex++) {
			const reel = curReels[this._currentReelOrder[reelIndex]];
			positions.push(ServerRandomUtils.randomInt(0, reel.length - 1));
			if (cheats.isCheatsEnabled && cheats.cheatPositions){
				for (let i = 0; i < cheats.cheatPositions.length; i++) {
					if (cheats.cheatPositions[i] >= 0) {
						positions[i] = cheats.cheatPositions[i];
					}
				}
			}
		}

		const visibleSymbols: number[][] = [];
		for (let i: number = 0; i < ServerAvalancheReels.REELS; i++) {
			visibleSymbols[i] = [];
			for (let j: number = 0; j < ServerAvalancheReels.ROWS; j++) {
				const reelIndex: number =  this._currentReelOrder[this._currentReelOrder[i]];
				visibleSymbols[i][j] = this.getSymbolFromReel(curReels, reelIndex, positions[i] + j);
			}
		}

		return {visibleReelsPositions: positions, visibleReels: visibleSymbols};
	}

	public killWinLinesSymbols(currentReels: CurrentReelsCombination, winLines: ServerWinLine[]): CurrentReelsCombination {
		for (const wl of winLines) {
			for (const ws of wl.winSymbols) {
				if (currentReels.visibleReels[ws.position.reel][ws.position.row] === W) {
					for (let i = 0; i < currentReels.visibleReels[ws.position.reel].length; i++) {
						currentReels.visibleReels[ws.position.reel][i] = -1;
					}
				}
				currentReels.visibleReels[ws.position.reel][ws.position.row] = -1;
			}
		}

		return currentReels;
	}

	public dropDownSymbols(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		// tslint:disable-next-line:prefer-for-of
		for (let reelIndex: number = 0; reelIndex < currentReels.visibleReels.length; reelIndex++) {
			// starting from (lowest sym pos - 1)
			for (let rowIndex: number = currentReels.visibleReels[reelIndex].length - 2; rowIndex >= 0; rowIndex--) {
				let currentRow: number = rowIndex;
				let isAtFinalPosition: boolean = false;
				while (!isAtFinalPosition) {
					const curSymbol: number = currentReels.visibleReels[reelIndex][currentRow];
					const symBelow: number = currentRow < currentReels.visibleReels[reelIndex].length - 1 ? currentReels.visibleReels[reelIndex][currentRow + 1] : -2;

					if (curSymbol >= 0 && symBelow === -1) {
						currentReels.visibleReels[reelIndex][currentRow + 1] = curSymbol;
						currentReels.visibleReels[reelIndex][currentRow] = -1;
						currentRow++;
					} else {
						isAtFinalPosition = true;
					}
				}
			}
		}

		return currentReels;
	}


	/**
	 * returns list of new symbols
	 * @param currentReels
	 * @param reelset
	 * @param randomMultiplier
	 * @param avalancheMultiplier
	 */
	public addNewSymbols(currentReels: CurrentReelsCombination, reelset: Reelsets, randomMultiplier: number, avalancheMultiplier: number): number[][] {
		const specialCaseChance: number = ServerRandomUtils.randomInt(1, 1000);
		const specialCaseReelsOrder: number[] = [];
		let hasSpecialCase: boolean = false;
		if (specialCaseChance <= 165 && randomMultiplier === 1 && avalancheMultiplier === 1) {
			hasSpecialCase = true;
			for (let reelIndex: number = 0; reelIndex < ServerAvalancheReels.REELS; reelIndex++) {
				specialCaseReelsOrder.push(ServerRandomUtils.randomInt(0, 5));
			}

		}
		const curReelset: number[][] = this.getReelset(reelset);
		const newSymbols: number[][] = [];
		for (let i: number = 0; i < ServerAvalancheReels.REELS; i++) {
			newSymbols[i] = [];
			let reelIndex: number;
			if (hasSpecialCase) {
				reelIndex = this._currentReelOrder[i];
			} else {
				reelIndex = this._currentReelOrder[i];
			}

			const reelPositionToStartWith: number = ServerRandomUtils.randomInt(0, curReelset[reelIndex].length - 1);
			for (let j: number = ServerAvalancheReels.ROWS - 1; j >= 0; j--) {
				if (currentReels.visibleReels[i][j] === -1) {
					currentReels.visibleReels[i][j] = this.getSymbolFromReel(curReelset, reelIndex, reelPositionToStartWith - j);
					newSymbols[i].unshift(currentReels.visibleReels[i][j]);
					currentReels.visibleReelsPositions[i]--;
				}
			}
		}

		return newSymbols;
	}

	protected hasExpandedWildOnReel(reelIndex: number, expandedWilds: ExpandedWildData[]): boolean {
		if (expandedWilds) {
			for (const ew of expandedWilds) {
				if (ew.wildPosition.reel === reelIndex) {
					return true;
				}
			}
		}

		return false;
	}

	public getNonWinningSymolZzList(currentReels: CurrentReelsCombination, expandedWilds: ExpandedWildData[]): ServerSymbolPosition[] {
		const nwPositions: ServerSymbolPosition[] = [];
		for (let i: number = 0; i < ServerAvalancheReels.REELS; i++) {
			if (!this.hasExpandedWildOnReel(i, expandedWilds)) {
				for (let j: number = 0; j < ServerAvalancheReels.ROWS; j++) {
					nwPositions.push({reel: i, row: j});
				}
			}
		}

		const winLines: ServerWinLine[] = new ServerWaysWinChecker().findWins(currentReels.visibleReels);

		const winIndexes: number[] = [];
		for (const wl of winLines) {
			for (const ws of wl.winSymbols) {
				const index: number = nwPositions.findIndex((winSymbol: ServerSymbolPosition) => {
					return ws.position.reel === winSymbol.reel && ws.position.row === winSymbol.row;
				});

				if (index >= 0) {
					winIndexes.push(index);
				}
			}
		}

		for (const wi of winIndexes) {
			nwPositions.splice(wi, 1);
		}

		return nwPositions;
	}

	protected getSymbolFromReel(reels: number[][], reelIndex: number, index: number): number {
		let symIndex: number = index;

		while (!this.isValidSymIndex(reels, reelIndex, symIndex)) {
			if (symIndex >= reels[reelIndex].length) {
				symIndex = symIndex % reels[reelIndex].length;
			} else if (symIndex < 0) {
				symIndex = reels[reelIndex].length + symIndex;
			}
		}

		return reels[reelIndex][symIndex];
	}

	protected isValidSymIndex(reels: number[][], reelIndex: number, index: number): boolean {
		return index >= 0 && index < reels[reelIndex].length;
	}

	public tryToAddMegablocks(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		const createMegablockNumber = ServerRandomUtils.randomInt(1, 100);

		this._currentMegablock = null;

		if (createMegablockNumber >= 30) {
			return this.megablockCaseSelector(currentReels);
		}

		return currentReels;
	}

	protected megablockCaseSelector(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		const megablockNumber: number = ServerRandomUtils.randomInt(1, 100);

		if (megablockNumber < 95) {
			return this.megablockCommon2x2Case(currentReels);
		} else {
			return this.megablockUncommonCases(currentReels);
		}
	}

	protected megablockUncommonCases(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		const caseNumber: number = ServerRandomUtils.randomInt(1, 5);
		console.log('Megablock uncommon case', 1, 'selected');

		switch (caseNumber) {
			case 1:
				return this.meagaBlockUncommonCase1(currentReels, null);
			case 2:
				return this.meagaBlockUncommonCase2(currentReels);
			case 3:
				return this.meagaBlockUncommonCase3(currentReels, null);
			case 4:
				return this.meagaBlockUncommonCase4(currentReels, null);
			case 5:
				return this.meagaBlockUncommonCase5(currentReels);
			default:
				break;
		}
	}

	protected megablockCommon2x2Case(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		const size: number = 2;
		/* 
		2x2 megablock top corner position will be uniformly distributed verticaly on rows 1,2,3,4,5. */
		const rowIndex = ServerRandomUtils.randomInt(0, 4);

		/*
		70% chance to set left corner on reel 5, otherwise on reel 4. 
		*/
		const reelIndex = ServerRandomUtils.randomValueWithWeights([4, 3], [7, 3]);

		/*
		20% chance to make it of low paying symbols (L4, L3, L2, L1), the rest chance will make it of high paying symbols (H5, H4, H3, H2, H1)
		*/
		const symbolSet = ServerRandomUtils.randomValueWithWeights([[H5, H4, H3, H2, H1], [L4, L3, L2, L1]], [8, 2]);
		const weight = [];
		symbolSet.forEach(() => {
			weight.push(1);
		});
		const symbol = ServerRandomUtils.randomValueWithWeights(symbolSet, weight);

		const startPosition: ServerSymbolPosition = {reel: reelIndex, row: rowIndex};

		return this.placeMegablockInReels(currentReels, startPosition, size, symbol);
	}

	protected meagaBlockUncommonCase1(currentReels: CurrentReelsCombination, nextQuadrant: number): CurrentReelsCombination {
		/* 
		Divide 6x6 reels into 4 areas of 3x3. 
		[0] [2]	
		[1] [3]
		*/
		const reelQuadrants = [{reel: 0, row: 0}, {reel: 0, row: 3}, {reel: 3, row: 0}, {reel: 3, row: 3}];
		let quadrant: number = 0;
		let position: ServerSymbolPosition = null;

		/*
		Take random number 0..3 to determine which area will be used for megablock. 
		*/
		if (nextQuadrant) {
			console.log('nextquadrant selected:', nextQuadrant);
			quadrant = nextQuadrant;
		} else {
			quadrant = ServerRandomUtils.randomInt(0, 3);
			console.log('quadrant selected:', quadrant);
		}

		/*
		20% chance to make it size of 3x3, otherwise 2x2. 
		*/
		const size = ServerRandomUtils.randomValueWithWeights([3, 2], [2, 8]);
		/*
		If size 3x3, then set one out of 5 high paying symbols for megablock type. 
		Otherwise, if 2x2: 20% chance to be L1..L4, otherwise H1..H5. 2x2 symbol should be placed in random position inside selected 3x3 area. 
		*/
		let symbol: number;
		if (size === 3) {
			console.log('size:', size);
			symbol = ServerRandomUtils.randomValueWithWeights([H5, H4, H3, H2, H1], [1, 1, 1, 1, 1]);
			position = {reel: reelQuadrants[quadrant].reel, row: reelQuadrants[quadrant].row};
		} else {
			console.log('size:', size);
			const symbolSet = ServerRandomUtils.randomValueWithWeights([[H5, H4, H3, H2, H1], [L4, L3, L2, L1]], [8, 2]);
			const weight = [1, 1, 1, 1, 1];
			weight.length = symbolSet.length;
			symbol = ServerRandomUtils.randomValueWithWeights(symbolSet, weight);

			const xPositionOffset = ServerRandomUtils.randomInt(0, 1);
			const yPositionOffset = ServerRandomUtils.randomInt(0, 1);

			position = {reel: reelQuadrants[quadrant].reel + xPositionOffset, row: reelQuadrants[quadrant].row + yPositionOffset};
		}
		/*
		If 30% chance successful there might be awarded another megablock. 
		Select one random area of 3x3 again. 
		If selected the same one as for the 1st megablock, skip awarding another block completely, otherwise do the same as for the previous one, with the new choosing of megablock symbol (can be the same as the previous one, but doesn't have to).
		*/
		if (!nextQuadrant && ServerRandomUtils.randomValueWithWeights([false, true], [7, 3])) {
			const nextQuadrant = ServerRandomUtils.randomInt(0, 3);
			if (nextQuadrant === quadrant) {
				return this.placeMegablockInReels(currentReels, position, size, symbol);
			} else {
				currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
				this.meagaBlockUncommonCase1(currentReels, nextQuadrant);
			}
		} else {
			return this.placeMegablockInReels(currentReels, position, size, symbol);
		}
	}

	protected meagaBlockUncommonCase2(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		/*
		Size is 3x3, symbol is H1 or H2 or H3. 
		*/

		const symbolValue: number = ServerRandomUtils.randomValueWithWeights([H1, H2, H3], [1, 1, 1]);
		/*
		Vertical position is randomly selected to be 2, 3, 4 (top left corner of the megablock). 
		*/
		const rowPosition: number = ServerRandomUtils.randomInt(1, 3);
		/*
		Horisontal position is randomly selected to be 2, 3, 4 (top left corner of the megablock)
		*/
		const reelPosition: number = ServerRandomUtils.randomInt(1, 3);

		const symbolPosition: ServerSymbolPosition = {reel: reelPosition, row: rowPosition};

		return this.placeMegablockInReels(currentReels, symbolPosition, 3, symbolValue);
	}

	protected meagaBlockUncommonCase3(currentReels: CurrentReelsCombination, nextSection: number): CurrentReelsCombination {
		/* 
		Divide 6x6 reels into 2 areas of 6x3 - top and bottom. 
		*/
		const reelIndexes = [1, 2, 3];
		const rowIndexes = [0, 3];

		/*
		Select one area randomly. 
		*/
		let chosenSection: number;
		if (nextSection) {
			chosenSection = nextSection;
		} else {
			chosenSection = ServerRandomUtils.randomInt(0, 1);
		}

		/*
		20% chance to make it 3x3, otherwise 2x2. 
		3x3 megablock  can be H1..H5. 
		2x2 megablock 20% chance to be L1..L4, otherwise H1..H5. 
		*/
		const size = ServerRandomUtils.randomValueWithWeights([2, 3], [8, 2]);
		let symbol: number;
		if (size === 3) {
			symbol = ServerRandomUtils.randomValueWithWeights([H1, H2, H3, H4, H5], [1, 1, 1, 1, 1]);
		} else {
			const symbolSet = ServerRandomUtils.randomValueWithWeights([[H5, H4, H3, H2, H1], [L4, L3, L2, L1]], [8, 2]);
			const weight = [];
			symbolSet.forEach(() => {
				weight.push(1);
			});
			symbol = ServerRandomUtils.randomValueWithWeights(symbolSet, weight);
		}

		/*
		Place top left corner on reels 2, 3 or 4, row 1 or 4 (depending of selected area). 
		If 2x2 megablock, 50% chance to increase reel by 1, and 50% chance to increase row by 1. 
		*/
		let position: ServerSymbolPosition;
		let yOffset: number = 0;
		let xOffset: number = 0;
		if (size === 2) {
			yOffset = ServerRandomUtils.randomInt(0, 1);
			xOffset = ServerRandomUtils.randomInt(0, 1);
		}
		position = {reel: reelIndexes[ServerRandomUtils.randomInt(0, 2)] + xOffset, row: rowIndexes[chosenSection] + yOffset};

		/*
		If 5% chance successful, do the same for the remaining 6x3 area. 
		Select megablock symbol again, independently of the previous selection. 
		*/
		if (ServerRandomUtils.randomValueWithWeights([true, false], [1, 20]) && !nextSection) {
			const newChosenSection = chosenSection === 1 ? 0 : 1;
			currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
			this.meagaBlockUncommonCase3(currentReels, newChosenSection);
		} else {
			return this.placeMegablockInReels(currentReels, position, size, symbol);
		}
	}

	protected meagaBlockUncommonCase4(currentReels: CurrentReelsCombination, nextSection: number): CurrentReelsCombination {
		/*
		Divide 6x6 reels into 2 areas of 3x6 - left and right. 
		*/
		const reelIndexes = [0, 3];
		const rowIndexes = [0, 1, 2, 3];

		/*
		Select one area randomly. 
		*/
		let chosenSection: number;
		if (nextSection) {
			chosenSection = nextSection;
		} else {
			chosenSection = ServerRandomUtils.randomInt(0, 1);
		}
		/*
		20% chance to make it 3x3, otherwise 2x2. 3x3 megablock can be H1..H5. 
		*/
		const size = ServerRandomUtils.randomValueWithWeights([2, 3], [8, 2]);
		let symbol: number;
		if (size === 3) {
			symbol = ServerRandomUtils.randomValueWithWeights([H1, H2, H3, H4, H5], [1, 1, 1, 1, 1]);
		} else {
			const symbolSet = ServerRandomUtils.randomValueWithWeights([[H5, H4, H3, H2, H1], [L4, L3, L2, L1]], [8, 2]);
			const weight = [];
			symbolSet.forEach(() => {
				weight.push(1);
			});
			symbol = ServerRandomUtils.randomValueWithWeights(symbolSet, weight);
		}
		/*
		2x2 megablock 20% chance to be L1..L4, otherwise H1..H5. 
		Place top left corner on reels 1 or 4, row 1,2,3,4 (depending of selected area). 
		If 2x2 megablock, 50% chance to increase reel by 1, and 50% chance to increase row by 1. 
		*/
		let position: ServerSymbolPosition;
		let yOffset: number = 0;
		let xOffset: number = 0;
		if (size === 2) {
			yOffset = ServerRandomUtils.randomInt(0, 1);
			xOffset = ServerRandomUtils.randomInt(0, 1);
		}
		position = {reel: reelIndexes[ServerRandomUtils.randomInt(0, 2)] + xOffset, row: rowIndexes[chosenSection] + yOffset};

		/*
		If 5% chance successful, do the same for the remaining 3x6 area. 
		Select megablock symbol again, independently of the previous selection.
		*/
		if (ServerRandomUtils.randomValueWithWeights([true, false], [1, 20]) && !nextSection) {
			const newChosenSection = chosenSection === 1 ? 0 : 1;
			currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
			this.meagaBlockUncommonCase3(currentReels, newChosenSection);
		} else {
			return this.placeMegablockInReels(currentReels, position, size, symbol);
		}
	}

	protected meagaBlockUncommonCase5(currentReels: CurrentReelsCombination): CurrentReelsCombination {
		/*
		Divide 6x6 reels into 9 areas of 2x2 size. 
		*/
		/*
		[0] [3]	[6]
		[1] [4] [7]
		[2] [5] [8]
		*/
		const reelDivitions = [{reel: 0, row: 0}, {reel: 0, row: 2}, {reel: 0, row: 4}, {reel: 2, row: 0}, {reel: 2, row: 2}, {reel: 2, row: 4}, {reel: 4, row: 0}, {reel: 4, row: 2}, {reel: 4, row: 4}];
		const selectedSections: number[] = [];
		const symbolValues: number[] = [];
		const highSymbolSet: number[] = [H1, H2, H3, H4, H5];
		const lowSymbolSet: number[] = [L1, L2, L3, L4];

		/*
		If 25% chance successful, 
			do: select random area; 
			fill the area with 2x2 megablock; 
			20% chance megablock symbol will be L1..L4, remaining 80% megablock symbol will be H1..H5. 
		*/
		if (ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
			selectedSections.push(ServerRandomUtils.randomInt(0, 8));
			const symbolSet = ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
			const weight = [];
			symbolSet.forEach(() => {
				weight.push(1);
			});

			symbolValues.push(ServerRandomUtils.randomValueWithWeights(symbolSet, weight));
		}

		/*
		If 25% chance successful, 
			do: select random area;  
			2x2 megablock; 
			20% chance megablock symbol will if area not used already, fill the area with be L1..L4, remaining 80% megablock symbol will be H1..H5. 
		*/
		if (ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
			const selectedSection = ServerRandomUtils.randomInt(0, 8);
			let sectionAvailable: boolean = true;
			selectedSections.forEach((prevSelection) => {
				if (prevSelection === selectedSection) {
					sectionAvailable = false;
				}
			});

			if (sectionAvailable) {
				const symbolSet = ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
				const weight = [];
				symbolSet.forEach(() => {
					weight.push(1);
				});

				symbolValues.push(ServerRandomUtils.randomValueWithWeights(symbolSet, weight));
			}
		}
		/*
		If 25% chance successful, 
			do: select random area; 
			if area not used already, fill the area with 2x2 megablock; 
			20% chance megablock symbol will be L1..L4, remaining 80% megablock symbol will be H1..H5. 

		This way, up to 3 megablocks may be added, but can end with no megablocks agt all as well.
		*/
		if (ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
			const selectedSection = ServerRandomUtils.randomInt(0, 8);
			let sectionAvailable: boolean = true;
			selectedSections.forEach((prevSelection) => {
				if (prevSelection === selectedSection) {
					sectionAvailable = false;
				}
			});

			if (sectionAvailable) {
				const symbolSet = ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
				const weight = [];
				symbolSet.forEach(() => {
					weight.push(1);
				});

				symbolValues.push(ServerRandomUtils.randomValueWithWeights(symbolSet, weight));
			}
		}

		if (symbolValues.length > 0) {
			for (let i = 0; i < symbolValues.length; i++) {
				currentReels = this.placeMegablockInReels(currentReels, reelDivitions[selectedSections[i]], 2, symbolValues[i]);
			}

			return currentReels;
		} else {
			return currentReels;
		}
	}

	protected placeMegablockInReels(currentReels: CurrentReelsCombination, position: ServerSymbolPosition, size: number, symbol: number): CurrentReelsCombination {
		// Replace symbols in the current reelset with the one from the megablock at position with size.

		console.log('before megablock insertion', currentReels);
		console.log('symboltype', symbol, 'startposition', position);
		let isFull: boolean = true;
		for (let xPos = position.reel; xPos < position.reel + size; xPos++) {
			for (let yPos = position.row; yPos < position.row + size; yPos++) {
				if (currentReels.visibleReels[xPos][yPos] !== CHEST_RESPIN
					&& currentReels.visibleReels[xPos][yPos] !== CHEST_EXPLODE
					&& currentReels.visibleReels[xPos][yPos] !== CHEST_WILD
					&& currentReels.visibleReels[xPos][yPos] !== MIMIC_CHEST
					&& currentReels.visibleReels[xPos][yPos] !== W
					&& currentReels.visibleReels[xPos][yPos] !== E
					&& currentReels.visibleReels[xPos][yPos] !== SC
					&& currentReels.visibleReels[xPos][yPos] !== KEY) {
					currentReels.visibleReels[xPos][yPos] = symbol;
				} else {
					isFull = false;
				}
			}
		}

		this._currentMegablock = {isFull, position, size};

		console.log('after megablock insertion', symbol, currentReels);

		return currentReels;
	}

	public get currentMegablock(): MegablockData {
		return this._currentMegablock;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/reels/ServerAvalancheReels.ts